import agent from "../shared/agent";
import { action, makeAutoObservable } from "mobx"

class RelatoriosStore {
    inProgress = false;

    dashboard = null;

    error = "";

    setError(error) {
        this.error = error;
    }

    reset() {
        this.dashboard = null;
    }

    setDashboard(dashboard) {
        this.dashboard = dashboard;
    }

    constructor() {
        makeAutoObservable(this);
    }

    buscarDashboard(dataInicial, dataFinal) {
        this.inProgress = true;

        return agent.Relatorios.buscarDashboard(dataInicial, dataFinal)
            .then((res) => {
                if (res.CodigoRetorno === 1) {
                    this.setError("");
                    this.setDashboard(res);
                    return res;
                } else {
                    this.setError(res.Mensagem);
                    throw res;
                }
            })
            .finally(
                action(() => {
                    this.inProgress = false;
                })
            )
    }
}

export default new RelatoriosStore();
